import { GameConstants } from "../../GameConstants";

import { GameVars } from "../../GameVars";
import { MazeContainer } from "./MazeContainer";
import { MazeManager } from "./MazeManager";
import { AudioManager } from "../../AudioManager";

export class MazeCursor extends Phaser.GameObjects.Container {

    public moving: boolean;

    private arrows: Phaser.GameObjects.Image[];
    private arrowFlashes: Phaser.GameObjects.Image[];
    private path: { r: number, c: number }[];
    private i: number;
    private f: number;
    private j: number;
    private arrowFlashesShown: boolean;
    private pulsing: boolean;
    private tweenToBeCompleted: boolean;
    private mazeCursor: Phaser.GameObjects.Image;
    private pulsingImage: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.scaleY = GameVars.scaleY;

        this.moving = false;
        this.pulsing = false;
        this.f = 0;
        this.j = 0;
        this.arrowFlashesShown = false;

        this.tweenToBeCompleted = false;

        this.pulsingImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "efecto_pulsante_cursor");
        this.pulsingImage.setScale(.75);
        this.add(this.pulsingImage);

        this.scene.tweens.add({
            targets: this.pulsingImage,
            scaleX: 1,
            scaleY: 1,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000,
            repeat: -1,
            yoyo: true
        });

        this.mazeCursor = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "cursor");
        this.add(this.mazeCursor);

        this.addArrows();
        this.setArrows();

        // HAY Q HACER ESTO PQ EL METODO UPDATE NO SE UTILIZA DE MANERA AUTOMATICA
        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (GameVars.pause) {
            return;
        }

        if (this.tweenToBeCompleted) {
            this.tweenToBeCompleted = false;
            this.onTweenCompleted();
        }

        if (!this.pulsing && GameVars.time < 10) {
            this.pulsing = true;
            this.f = 0;
        }

        if (this.pulsing) {

            this.f++;

            if (this.f === 15) {

                this.f = 0;

                if (this.mazeCursor.scaleX === 1) {
                    this.mazeCursor.scaleX = 1.15;
                    this.mazeCursor.scaleY = 1.15;
                } else {
                    this.mazeCursor.scaleX = 1;
                    this.mazeCursor.scaleY = 1;
                }
            }
        }

        if (this.arrowFlashesShown) {

            this.j ++;

            if (this.j === 10) {
                this.arrowFlashesShown = false;
                for (let i = 0; i < this.arrowFlashes.length; i ++) {
                    this.arrowFlashes[i].visible = false;
                }
            }
        }
    }

    public move(path: { r: number, c: number }[]): void {

        this.moving = true;
        this.pulsingImage.visible = false;

        for (let i = 0; i < this.arrows.length; i++) {
            this.arrows[i].visible = false;
        }

        this.path = path;
        this.i = 0;

        let t: number;

        if (this.path[this.i].r === GameVars.goalPosition.r && this.path[this.i].c === GameVars.goalPosition.c) {
            t = 500;
            MazeManager.lastTween();
        } else {
            t = GameConstants.SLOW_MOTION ? 500 : 75;
        }

        this.scene.tweens.add({
            targets: this,
            x: (this.path[this.i].c + .5) * GameVars.l - MazeContainer.currentInstance.dx,
            y: (this.path[this.i].r + .5) * GameVars.l - MazeContainer.currentInstance.dy,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: t,
            onComplete: this.onTweenCompleted,
            onCompleteScope: this
        });

        AudioManager.playSound("start_cursor_movement");
    }

    public gameOver(): void {

        this.pulsing = false;
        this.mazeCursor.scaleX = 1;
        this.mazeCursor.scaleY = 1;

        this.mazeCursor.destroy();

        // TODO: HACER QUE EXPLOTE
        for (let i = 0; i < this.arrows.length;  i++) {
            this.arrows[i].visible = false;
            this.arrowFlashes[i].visible = false;
        }

        this.addExplosion();
    }

    private onTweenCompleted(): void {

        if (GameVars.gameOver || GameVars.pause) {

            if (GameVars.pause) {
                this.tweenToBeCompleted = true;
            }
            return;
        }

        MazeManager.cursorMovedOneCell({ r: this.path[this.i].r, c: this.path[this.i].c });

        if (this.i < this.path.length - 1) {

            this.i++;

            let t: number;

            if (this.path[this.i].r === GameVars.goalPosition.r && this.path[this.i].c === GameVars.goalPosition.c) {
                t = 500;
                MazeManager.lastTween();
            } else {
                t = GameConstants.SLOW_MOTION ? 500 : 75;
            }

            this.scene.tweens.add({
                targets: this,
                x: (this.path[this.i].c + .5) * GameVars.l - MazeContainer.currentInstance.dx,
                y: (this.path[this.i].r + .5) * GameVars.l - MazeContainer.currentInstance.dy,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: t,
                onComplete: this.onTweenCompleted,
                onCompleteScope: this
            });

        } else {

            this.moving = false;
            this.pulsingImage.visible = true;

            MazeManager.cursorStoppedMoving();

            if (!GameVars.levelCompleted) {
                this.setArrows();
            }

            AudioManager.playSound("stop_movement");
        }
    }

    private addArrows(): void {

        this.arrows = [];

        const l = GameVars.l * .725;

        let arrow = new Phaser.GameObjects.Image(this.scene, 0, -l, "texture_atlas_1", "arrow");
        arrow.originY = 1;
        arrow.visible = false;
        this.add(arrow);

        this.arrows.push(arrow);

        arrow = new Phaser.GameObjects.Image(this.scene, l, 0, "texture_atlas_1", "arrow");
        arrow.originY = 1;
        arrow.angle = 90;
        arrow.visible = false;
        this.add(arrow);

        this.arrows.push(arrow);

        arrow = new Phaser.GameObjects.Image(this.scene, 0, l, "texture_atlas_1", "arrow");
        arrow.originY = 1;
        arrow.angle = 180;
        arrow.visible = false;
        this.add(arrow);

        this.arrows.push(arrow);

        arrow = new Phaser.GameObjects.Image(this.scene, -l, 0, "texture_atlas_1", "arrow");
        arrow.originY = 1;
        arrow.angle = 270;
        arrow.visible = false;
        this.add(arrow);

        this.arrows.push(arrow);

        this.arrowFlashes = [];

        let arrowFlash = new Phaser.GameObjects.Image(this.scene, 0, -l, "texture_atlas_1", "destello_arrow");
        arrowFlash.originY = 1;
        arrowFlash.visible = false;
        this.add(arrowFlash);

        this.arrowFlashes.push(arrowFlash);

        arrowFlash = new Phaser.GameObjects.Image(this.scene, l, 0, "texture_atlas_1", "destello_arrow");
        arrowFlash.originY = 1;
        arrowFlash.angle = 90;
        arrowFlash.visible = false;
        this.add(arrowFlash);

        this.arrowFlashes.push(arrowFlash);

        arrowFlash = new Phaser.GameObjects.Image(this.scene, 0, l, "texture_atlas_1", "destello_arrow");
        arrowFlash.originY = 1;
        arrowFlash.angle = 180;
        arrowFlash.visible = false;
        this.add(arrowFlash);

        this.arrowFlashes.push(arrowFlash);

        arrowFlash = new Phaser.GameObjects.Image(this.scene, -l, 0, "texture_atlas_1", "destello_arrow");
        arrowFlash.originY = 1;
        arrowFlash.angle = 270;
        arrowFlash.visible = false;
        this.add(arrowFlash);

        this.arrowFlashes.push(arrowFlash);
    }

    private setArrows(): void {

        if (GameVars.validDirections.indexOf(GameConstants.DIR_UP) !== -1) {
            this.arrows[0].visible = true;
            this.arrowFlashes[0].visible = true;
        }

        if (GameVars.validDirections.indexOf(GameConstants.DIR_DOWN) !== -1) {
            this.arrows[2].visible = true;
            this.arrowFlashes[2].visible = true;
        }

        if (GameVars.validDirections.indexOf(GameConstants.DIR_LEFT) !== -1) {
            this.arrows[3].visible = true;
            this.arrowFlashes[3].visible = true;
        }

        if (GameVars.validDirections.indexOf(GameConstants.DIR_RIGHT) !== -1) {
            this.arrows[1].visible = true;
            this.arrowFlashes[1].visible = true;
        }

        for (let i = 0; i < this.arrowFlashes.length; i ++) {

            if (this.arrowFlashes[i].visible) {
                this.arrowFlashes[i].scaleX = 1;

                this.scene.tweens.add({
                    targets: this.arrowFlashes[i],
                    scaleY: 2,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 120,
                });
            }
        }

        this.arrowFlashesShown = true;
        this.j = 0;
    }

    private addExplosion(): void {

        this.pulsingImage.visible = false;

        for (let i = 0; i < 40; i ++) {

            const particles = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "explosion_particles");
            particles.setOrigin(0, .5);
            particles.setScale(.5);
            particles.rotation = 2 * Math.PI * Math.random();
            this.add(particles);

            const px = GameConstants.GAME_HEIGHT * (1 + .5 * Math.random()) * Math.cos(particles.rotation);
            const py = GameConstants.GAME_HEIGHT * (1 + .5 * Math.random()) * Math.sin(particles.rotation);

            const t = 750 + 2500 * Math.random();

            this.scene.tweens.add({
                targets: particles,
                x: px,
                y: py,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: t,
                onComplete: function(): void {
                    particles.destroy();
                },
                onCompleteScope: this
            });
        }

        const lightExplosion = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "explosion_light");
        lightExplosion.setScale(0);
        this.add(lightExplosion);

        this.scene.tweens.add({
            targets: lightExplosion,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600,
            delay: 250
        });

        this.scene.tweens.add({
            targets: lightExplosion,
            scaleX: 2.5,
            scaleY: 2.5,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 850,
            onComplete: function(): void {
                lightExplosion.destroy();
            },
            onCompleteScope: this
        });

        AudioManager.playSound("gameover_explosion");
    }
}
